<div class="container">
  <div class="header-wrapper">
    <div class="header-inner">
      <div class="header-div">
        <div>
          <p class="title">My Profile</p>
          <p class="title-note">Please fill in the * items so we can complete your profile.</p>
        </div>
        <button
          mat-flat-button
          type="button"
          class="btn"
          [disabled]="!isSaveBtnEnabled"
          (click)="saveUserInfo()"
        >
          Save
        </button>
      </div>
    </div>
  </div>

  <div class="profile-body">
    <!-- Side Navigation -->
    <nav class="side-nav">
      @for (section of sideNavSections; track section.id) {
        <button
          class="side-nav-link"
          [class.active]="activeSection === section.id"
          (click)="scrollToSection(section.id)"
        >
          {{ section.label }}
        </button>
      }
    </nav>
  <ngx-spinner aria-hidden="true"></ngx-spinner>
  <span class="sr-only" aria-live="polite" role="status">{{ spinnerLoadingMessage }}</span>
    <div class="main-div" (scroll)="onScroll()" #contentDiv>
      @if (isSaving) {
        <app-loader-overlay loadingMessage="Saving your profile…" loadedMessage="Profile saved." />
      }
      <form class="content-div" [formGroup]="userForm">
        <!-- Form Sections -->
        <div class="form-sections">

      <div class="section-div" id="section-name">
        <div class="row-div">
          <div class="full-width">
            <p class="input-label">First name *</p>
            <mat-form-field class="full-width">
              <input
                type="text"
                matInput
                formControlName="firstName"
              >
              @if (userForm.get('firstName')?.hasError('required')) {
                <mat-error class="input-error">First name is required</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="full-width">
            <p class="input-label">Last name *</p>
            <mat-form-field class="full-width">
              <input
                type="text"
                matInput
                formControlName="lastName"
              >
              @if (userForm.get('lastName')?.hasError('required')) {
                <mat-error class="input-error">Last name is required</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div>
          <p class="input-label disabled-input-label">Email</p>
          <mat-form-field class="full-width">
            <input
              matInput
              formControlName="email"
            >
          </mat-form-field>
        </div>
      </div>

      <div class="section-div" id="section-location">
        <p class="section-title">Location</p>
        <div>
          <p class="input-label">Current location *</p>
          <mat-form-field
            appearance="fill"
            class="full-width"
          >
            <input
              type="text"
              matInput
              formControlName="location"
              [matAutocomplete]="auto"
              (optionSelected)="onLocationSelected($event)"
              required
            />
            <mat-autocomplete #auto="matAutocomplete">
              @for (option of filteredLocations | async; track $index) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
              }
            </mat-autocomplete>

            @if (userForm.get('location')?.hasError('required') && (
              userForm.get('location')?.touched || userForm.get('location')?.dirty)
            ) {
              <mat-error class="input-error">
                Location is required
              </mat-error>
            }

            @if (
              userForm.get('location')?.hasError('invalidLocation') &&
              userForm.get('location')?.touched
            ) {
              <mat-error class="input-error">
                Invalid location
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div>
          <p class="input-label">Desired Work location *</p>
          <mat-form-field
            appearance="fill"
            class="full-width"
          >
            <input
              type="text"
              matInput
              formControlName="workLocation"
              [matAutocomplete]="autoWork"
              required
            />
            <mat-autocomplete
              #autoWork="matAutocomplete"
              (optionSelected)="onWorkLocationSelected($event)"
            >
              @for (option of filteredWorkLocations | async; track $index) {
                <mat-option [value]="option">
                  {{ option.description || option }}
                </mat-option>
              }
            </mat-autocomplete>

            @if (userForm.get('workLocation')?.hasError('required') && (
              userForm.get('workLocation')?.touched ||
              userForm.get('workLocation')?.dirty)
            ) {
              <mat-error class="input-error">
                Location is required
              </mat-error>
            }

            @if (
              userForm.get('workLocation')?.hasError('invalidLocation') &&
              userForm.get('workLocation')?.touched
            ) {
              <mat-error class="input-error">
                Invalid location
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="section-div education-section" id="section-education">
        <div class="education-heading">
          <p class="section-title">Education and Employment</p>
          <p class="section-subtitle">Current School Status</p>
        </div>

        <div class="row-div">
          <div class="full-width">
            <p class="input-label">Academic Year *</p>
            <mat-form-field appearance="fill" class="full-width">
              <mat-select formControlName="schoolYear">
                @for (year of schoolYearOptions; track $index) {
                  <mat-option [value]="year.value">{{ year.label }}</mat-option>
                }
              </mat-select>
              @if (userForm.get('schoolYear')?.hasError('required') && (
                userForm.get('schoolYear')?.touched || userForm.get('schoolYear')?.dirty)
              ) {
                <mat-error>
                  Please select year
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="full-width">
            <p class="input-label">Expected Graduation Year *</p>
            <mat-form-field appearance="fill" class="full-width">
              <mat-select formControlName="graduationYear">
                @for (year of schoolGraduationOptions; track $index) {
                  <mat-option [value]="year.value">{{ year.label }}</mat-option>
                }
              </mat-select>
              @if (userForm.get('graduationYear')?.hasError('required') && (
                userForm.get('graduationYear')?.touched || userForm.get('graduationYear')?.dirty)
              ) {
                <mat-error>
                  Graduation year is required
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        @if (!isAUTenant) {
          <div class="full-width">
            <p class="input-label">School Name *</p>
            <mat-form-field appearance="fill" class="full-width">
              <mat-select formControlName="schoolName" required>
                @for (name of schoolNameOptions; track $index) {
                  <mat-option [value]="name.value">{{ name.label }}</mat-option>
                }
              </mat-select>
              @if (userForm.get('schoolName')?.hasError('required') && (
                userForm.get('schoolName')?.touched || userForm.get('schoolName')?.dirty)
              ) {
                <mat-error>
                  School name is required
                </mat-error>
              }
            </mat-form-field>
            </div>
          } @else {
            <div class="full-width disabled-field">
              <p class="input-label disabled-input-label">School Name *</p>
              <mat-form-field appearance="fill" class="full-width">
                <input
                  matInput
                  formControlName="schoolName"
                >
              </mat-form-field>
            </div>
          }

          <div class="full-width">
            <p class="input-label">Intended/Declared Major</p>
            <mat-form-field appearance="fill" class="full-width">
              <input
                type="text"
                matInput
                formControlName="graduationMajor"
                [matAutocomplete]="autoMajor"
                class="major-text"
              />
              <mat-autocomplete #autoMajor="matAutocomplete" [displayWith]="displayMajorLabel">
                @for (major of filteredMajorOptions | async; track $index) {
                  <mat-option [value]="major">
                    {{ major.label }}
                  </mat-option>
                }
              </mat-autocomplete>

              @if (
                userForm.get('graduationMajor')?.hasError('invalidMajor') &&
                userForm.get('graduationMajor')?.touched
              ) {
                <mat-error class="input-error">
                  Invalid major
                </mat-error>
              }
            </mat-form-field>
          </div>

        <div class="work-div">
          <mat-checkbox formControlName="isWorking">
            Working while in school
          </mat-checkbox>

          <!-- Show job only when user selects above checkbox -->
          @if (userForm.get('isWorking')?.value) {
            <div class="divider">|</div>

            <mat-radio-group formControlName="jobType" class="job-radio-group">
              @for (option of jobOptions; track $index) {
                <mat-radio-button [value]="option.value">
                  {{ option.label }}
                </mat-radio-button>
              }
            </mat-radio-group>
          }
        </div>

        <div class="new-jobs-subsection">
          <div class="new-jobs-header">
            <p class="new-jobs-title">New Jobs and Internships</p>
            <button
              type="button"
              class="new-jobs-add-btn"
              (click)="openAddWorkExperience()"
              aria-label="Add work experience"
              matTooltip="Add"
              matTooltipPosition="above"
              matTooltipClass="remove-tooltip"
            >
              <i class="fa-regular fa-circle-plus" aria-hidden="true"></i>
            </button>
          </div>
          @if (reportedWorkExperiences.length === 0) {
            <div class="new-jobs-empty-row">
              <p class="new-jobs-empty-state">Your new jobs and internships will display here.</p>
            </div>
          } @else {
            @for (exp of reportedWorkExperiences; track exp.id) {
              <div class="new-jobs-row">
                <div class="new-jobs-role-type">
                  <p class="input-label">Role Type *</p>
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-select [value]="exp.workType" (selectionChange)="updateWorkType(exp, $event.value)">
                      @for (opt of workTypeOptions; track opt.value) {
                        <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="new-jobs-organization">
                  <p class="input-label">Organization *</p>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.org-error]="getOrgControl(exp.id).hasError('required') && getOrgControl(exp.id).touched">
                    <input
                      matInput
                      [formControl]="getOrgControl(exp.id)"
                      [matAutocomplete]="orgAuto"
                      (blur)="updateEmployerName(exp, getOrgControl(exp.id).value)"
                    />
                    @if (getOrgControl(exp.id).hasError('required') && getOrgControl(exp.id).touched) {
                      <span matSuffix class="org-error-icon"><i class="fa-solid fa-triangle-exclamation"></i></span>
                    }
                    <mat-autocomplete
                      #orgAuto="matAutocomplete"
                      (optionSelected)="updateEmployerName(exp, $event.option.value)"
                    >
                      @for (org of getFilteredOrgs(exp.id) | async; track org) {
                        <mat-option [value]="org">{{ org }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                  @if (getOrgControl(exp.id).hasError('required') && getOrgControl(exp.id).touched) {
                    <p class="org-error-message">Enter an organization name</p>
                  }
                </div>
                <button
                  type="button"
                  class="new-jobs-remove-btn"
                  (click)="removeWorkExperience(exp.id)"
                  aria-label="Remove work experience"
                  matTooltip="Remove"
                  matTooltipPosition="above"
                  matTooltipClass="remove-tooltip"
                >
                  <i class="fa-light fa-circle-minus" aria-hidden="true"></i>
                </button>
              </div>
            }
          }
        </div>
      </div>

      <div class="section-div" id="section-background">
        <p class="section-title">Background</p>
        <div class="row-div">
          <div class="full-width">
            <p class="input-label">Birth Year *</p>
            <mat-form-field
              appearance="fill"
              class="full-width"
            >
              <input
                type="text"
                matInput
                formControlName="birthYear"
                [matAutocomplete]="autoBirth"
                required
              />
              <mat-autocomplete #autoBirth="matAutocomplete">
                @for (year of filteredBirthYears | async; track $index) {
                  <mat-option [value]="year">
                    {{ year }}
                  </mat-option>
                }
              </mat-autocomplete>

              @if (userForm.get('birthYear')?.hasError('required') && (
                userForm.get('birthYear')?.touched || userForm.get('birthYear')?.dirty)
              ) {
                <mat-error class="input-error">
                  Year is required
                </mat-error>
              }

              @if (
                userForm.get('birthYear')?.hasError('invalidYear') &&
                userForm.get('birthYear')?.touched
              ) {
                <mat-error class="input-error">
                  Invalid Year
                </mat-error>
              }
            </mat-form-field>

            <mat-checkbox formControlName="birthYearNotToSay" class="birth-year-checkbox">
              Prefer not to say
            </mat-checkbox>
          </div>
        </div>

        <div class="row-div">
          <div class="full-width">
            <p class="input-label">Race/Ethnicity *</p>
            <div class="ethnicity-container">
              <div formArrayName="ethnicities">
                @for (option of ethnicityOptions; track $index) {
                  <mat-checkbox
                    [formControlName]="$index"
                    [disabled]="shouldDisableCheckboxEthnicity($index)"
                  >
                    {{ option.label }}
                  </mat-checkbox>
                }
              </div>

              <mat-checkbox
                formControlName="ethnicitySelfDescribe"
              >
                <div class="self-describe-container">
                  <label for="selfDescribeInput">Prefer to self describe</label>
                  <input
                    id="selfDescribeInput"
                    class="self-describe-input"
                    matInput
                    formControlName="ethnicitySelfDescribeText"
                    [disabled]="!userForm.get('ethnicitySelfDescribe')?.value"
                  />
                </div>
              </mat-checkbox>

              @if (userForm.get('ethnicities')?.hasError('required')) {
                <mat-error class="input-error">
                  Please select at least one ethnicity.
                </mat-error>
              }

              @if (userForm.get('ethnicitySelfDescribeText')?.invalid) {
                @if (userForm.get('ethnicitySelfDescribeText')?.hasError('required')) {
                  <mat-error class="input-error">
                    Please describe your ethnicity
                  </mat-error>
                }
                @if (userForm.get('ethnicitySelfDescribeText')?.hasError('minlength')) {
                  <mat-error class="input-error">
                    Minimum 3 characters required
                  </mat-error>
                }
                @if (userForm.get('ethnicitySelfDescribeText')?.hasError('maxlength')) {
                  <mat-error class="input-error">
                    Maximum 250 characters allowed
                  </mat-error>
                }
              }
            </div>
          </div>
        </div>

        <div class="row-div">
          <div class="full-width">
            <p class="input-label">Gender *</p>
            <mat-radio-group formControlName="gender" class="gender-radio-group" required>
              @for (option of genderOptions; track $index) {
                <mat-radio-button [value]="option.value">
                  {{ option.label }}
                </mat-radio-button>
              }

              <mat-radio-button value="self-describe">
                <div class="self-describe-container">
                  <label for="selfDescribeInput">Prefer to self describe</label>
                  <input
                    id="selfDescribeGender"
                    class="self-describe-input"
                    matInput
                    formControlName="genderSelfDescribeText"
                  />
                </div>
              </mat-radio-button>

              @if (userForm.get('gender')?.hasError('required') && (
                userForm.get('gender')?.touched || userForm.get('gender')?.dirty)
              ) {
                <mat-error class="input-error">
                  Gender is required
                </mat-error>
              }

              @if (userForm.get('genderSelfDescribeText')?.invalid) {
                @if (userForm.get('genderSelfDescribeText')?.hasError('required')) {
                  <mat-error class="input-error">
                    Please describe your gender
                  </mat-error>
                }
                @if (userForm.get('genderSelfDescribeText')?.hasError('minlength')) {
                  <mat-error class="input-error">
                    Minimum 3 characters required
                  </mat-error>
                }
                @if (userForm.get('genderSelfDescribeText')?.hasError('maxlength')) {
                  <mat-error class="input-error">
                    Maximum 250 characters allowed
                  </mat-error>
                }
              }
            </mat-radio-group>
          </div>
        </div>
      </div>

      <div class="section-div" id="section-email" [formGroup]="emailPreferencesFormGroup">
        <p class="section-title">Email Preferences</p>
        <div class="email-preferences-div">
          <mat-checkbox formControlName="productEmails">
            Receive emails related to my Futurenav Compass product experience
          </mat-checkbox>
          <mat-checkbox formControlName="marketingEmails">
            Receive marketing emails from other ETS products and services
          </mat-checkbox>
        </div>
      </div>

      <div class="section-div" id="section-additional">
        <p class="section-title">Additional Information</p>
        <div class="links-div">
          @for (item of additionalLinks; track $index) {
            @if (item.display) {
              <div class="links-row" (click)="onClickLink(item.key)">
                <p class="additional-links">{{ item.label }}</p>
                <img src="/assets/icons/forward-icon.svg" />
              </div>
            }
          }
        </div>
      </div>

      <div class="app-version-footer">
        <span>Version: {{ appVersion }}</span>
        <span class="version-divider">|</span>
        <span>Last Updated:  {{ lastUpdated }}</span>
      </div>

        </div><!-- /.form-sections -->
      </form>
    </div><!-- /.main-div -->
  </div><!-- /.profile-body -->
</div>
